import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ApiRouteTransactionDto } from '../../../../api/elite/dto/purchase-order.dto';
import { AlertService } from '../../../../core/services/alert.service';

export type PackingBoxCustomLabelType = {
  data: DataInfo;
  response: DataResponse;
  responseEdit: DataResponseEdit;
  approved: boolean;
};
type SalesOrderType = ApiRouteTransactionDto['insert']['body'];

type DataInfo =
  | {
      // lotNumbers: string[];

      workOrders: { id: number; title: string }[];
      type: 'create';
    }
  | {
      workOrders: { id: number; title: string }[];

      workOrderId: number;

      quantityOfLabels: number;
      quantityPerLabel: number;
      salesOrders: SalesOrderType[];
      type: 'edit';
    };
type DataResponse = {
  workOrderId: number;

  quantityOfLabels: number;
  quantityPerLabel: number;
};

type DataResponseEdit = {
  salesOrder: SalesOrderType;
  success: boolean;
  approved: boolean;
};
@Component({
  selector: 'app-custom-label',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './custom-label.component.html',
  styleUrls: ['./custom-label.component.sass'],
})
export class PackingBoxCustomLabelComponent implements OnInit {
  readonly data: DataInfo = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef);
  private readonly alertService = inject(AlertService);

  isEditDialog = this.data.type === 'edit';
  // showLotNumber = this.data.lotNumbers.length > 0;

  filterListWorkOrders: {
    id: number;
    title: string;
  }[] = [];

  filterSalesOrder: SalesOrderType[] =
    this.data.type === 'edit' ? this.data.salesOrders : [];

  searchWorkOrder = new FormControl<string>(undefined);
  searchSalesOrder = new FormControl<string>(undefined);

  form = new FormGroup({
    salesOrder: new FormControl<number>(undefined),
    workOrder: new FormControl<number>(
      this.data.type === 'edit' ? this.data.workOrderId : undefined,
      [Validators.required, Validators.min(1)]
    ),

    quantity: new FormControl<number>(
      this.data.type === 'edit' ? this.data.quantityPerLabel : undefined,
      [Validators.required, Validators.min(1)]
    ),
    numLabels: new FormControl<number>(
      this.data.type === 'edit' ? this.data.quantityOfLabels : undefined,
      [Validators.required, Validators.min(1)]
    ),
    addSalesOrder: new FormControl<boolean>(true),
    // lotNumber: new FormControl<string>(undefined),
  });

  constructor() {}

  ngOnInit(): void {
    this.filterListWorkOrders = this.data.workOrders;

    this.searchWorkOrder.valueChanges.subscribe((value) => {
      this.setFilterWorkOrders(value);
    });

    if (this.data.type === 'edit') {
      const fullList = this.data.salesOrders;

      this.form.get('salesOrder').setValidators(Validators.required);
      this.searchSalesOrder.valueChanges.subscribe((value) => {
        this.filterSalesOrder = fullList.filter((el) =>
          el.title.toUpperCase().includes(value?.toUpperCase())
        );
      });
      this.form.get('addSalesOrder').valueChanges.subscribe((val) => {
        if (val) {
          this.form.get('salesOrder').setValidators(Validators.required);
          this.form.get('salesOrder').enable();
        } else {
          this.form.get('salesOrder').clearValidators();
          this.form.get('salesOrder').setValue(undefined);
          this.form.get('salesOrder').disable();
        }
      });
      this.form.get('quantity').disable();
      this.form.get('numLabels').disable();
      this.form.get('workOrder').disable();
    }
  }

  setFilterWorkOrders(filterVal?: string): void {
    const currentVal = this.form.get('workOrder').value;

    this.filterListWorkOrders = this.data.workOrders.filter(
      (wo) =>
        !filterVal || wo.title.toUpperCase().includes(filterVal.toUpperCase())
    );

    if (!this.filterListWorkOrders.find((el) => el.id === currentVal)) {
      this.form.get('workOrder').setValue(undefined);
    }
  }
  onSave(): void {
    if (this.form.invalid) {
      return;
    }
    if (
      this.form.get('addSalesOrder').value &&
      this.form.get('salesOrder').value === undefined
    ) {
      this.alertService.error('Debe seleccionar una orden de venta');
      return;
    }
    if (this.data.type === 'edit') {
      const findValue = this.data.salesOrders.find(
        (el) => el.transactionId === this.form.get('salesOrder').value
      );

      this.dialogRef.close({
        salesOrder: findValue,
        success: true,
        approved: true,
      });
      return;
    }
    this.dialogRef.close({
      workOrderId: this.form.value.workOrder,
      quantityOfLabels: this.form.value.numLabels,
      quantityPerLabel: this.form.value.quantity,
      approved: true,
      // lotNumberSelected: this.form.get('lotNumber').value,
    });
  }
  onRejected() {
    this.dialogRef.close({
      approved: false,
    });
  }
}
